module.exports = __webpack_public_path__ + "img/iphone-white.b31cd20d.png";